import React from "react";

export default function ShieldCheckIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.68262 11.8856L11.4426 14.6269L17.4089 8.67188'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
      <path
        d='M20.6154 4.7025V10.4175C20.6253 12.3724 20.1485 14.2991 19.2279 16.0237C18.5825 17.2818 17.6657 18.3809 16.5438 19.2415C15.4218 20.1021 14.1228 20.7027 12.7404 21C11.358 20.7027 10.0589 20.1021 8.93699 19.2415C7.81506 18.3809 6.89828 17.2818 6.25289 16.0237C5.33231 14.2991 4.85547 12.3724 4.86539 10.4175V4.7025C10.0704 5.12625 12.7404 3 12.7404 3C12.7404 3 15.4104 5.12625 20.6154 4.7025Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeMiterlimit='10'
      />
    </svg>
  );
}
